import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";

import {
    LS_TERMS_AGREED_KEY,
    OfficePageType
} from "../../../core/constants/common";
import OfficePageService from "../../../core/service/OfficePageService";
import UserService from "../../../core/service/UserService";

const TermsModal = ({ t }) => {
    const termsAgreed = localStorage.getItem(LS_TERMS_AGREED_KEY);
    const [show, setShow] = useState(!termsAgreed || termsAgreed === 'false');
    const [termsContent, setTermsContent] = useState({});

    useEffect(() => {
        OfficePageService.getActivePage(OfficePageType.TERMS_OF_USE).then(res => {
			if (res.status !== 200) return;

			setTermsContent({
				name: res.data?.name ?? '',
				content: res.data?.content ?? '',
			});
		}).catch(error => {
		});
    }, []);

    const createMarkup = () => {
        return { __html: termsContent?.content };
    }

    const handleClose = () => {
        setShow(false);
    };

    const onAcceptTerms = () => {
        UserService.acceptTerms().then(res => {
			if (res.status !== 200) return;

			localStorage.setItem(LS_TERMS_AGREED_KEY, true);
            setShow(false);
		}).catch(error => {
		});
    };

    return (
        <>
            <Modal size="lg" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    < Modal.Title as="h5">{termsContent?.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div dangerouslySetInnerHTML={createMarkup()}>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => onAcceptTerms()}>
                        {t("Accept.label")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default withTranslation()(TermsModal);
